import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Verein from "./pages/Verein";
import Gewaesser from "./pages/Gewaesser";
import Termine from "./pages/Termine";
import Bestimmungen from "./pages/Bestimmungen";
import Gastkarten from "./pages/Gastkarten";
import Jugend from "./pages/Jugend";
import Mitgliedschaft from "./pages/Mitgliedschaft";
import Kontakt from "./pages/Kontakt";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/verein" element={<Verein />} />
          <Route path="/gewaesser" element={<Gewaesser />} />
          <Route path="/termine" element={<Termine />} />
          <Route path="/bestimmungen" element={<Bestimmungen />} />
          <Route path="/gastkarten" element={<Gastkarten />} />
          <Route path="/jugend" element={<Jugend />} />
          <Route path="/mitglied-werden" element={<Mitgliedschaft />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
      </Layout>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
